'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var List = require('../List/List.js');
var useDropdown = require('../../../hooks/useDropdown.js');
var TextButtonDropdown_parts = require('./TextButtonDropdown.parts.js');

/**
 * 텍스트 버튼 형태의 드롭다운 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {Array<{key: string, value: string, leadingIcon?: React.ReactNode}>} props.items - 드롭다운에 표시될 항목들의 배열
 * @param {{key: string, value: string, leadingIcon?: React.ReactNode}} props.selectedItem - 현재 선택된 항목 ({key, value, leadingIcon}[])
 * @param {(item: {key: string, value: string, leadingIcon?: React.ReactNode}) => void} props.onItemClick - 항목 클릭 시 실행될 콜백 함수 (item: {key, value, leadingIcon} => void)
 * @param {boolean} [props.alignRight=false] - 드롭다운 메뉴를 오른쪽 정렬할지 여부
 * @param {boolean} [props.disabled=false] - 드롭다운 메뉴를 비활성화할지 여부
 *
 * @example
 * const items = [
 *   { key: '1', value: '옵션 1' },
 *   { key: '2', value: '옵션 2', leadingIcon: <Icon /> },
 *   { key: '3', value: '옵션 3' }
 * ];
 *
 * const [selected, setSelected] = useState(items[0]);
 *
 * return (
 *   <TextButtonDropdown
 *     items={items}
 *     selectedItem={selected}
 *     onItemClick={setSelected}
 *     alignRight={false}
 *     disabled={item.length === 0}
 *   />
 * );
 */ const TextButtonDropdown = ({ items, selectedItem, onItemClick, alignRight = false, disabled = false })=>{
    const { isListOpen, ref, focusedIndex, handleItemClick, toggleListOpen, handleKeyDown } = useDropdown({
        items,
        onItemClick
    });
    return jsxRuntime.jsxs("div", {
        "data-testid": "design-system-text-button-dropdown",
        className: "relative flex w-fit flex-col gap-1 outline-none",
        ref: ref,
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        children: [
            jsxRuntime.jsx(TextButtonDropdown_parts.TextButton, {
                disabled: disabled,
                value: selectedItem.value,
                "data-testid": "design-system-text-button-dropdown--textButton",
                isListOpen: isListOpen,
                onClick: toggleListOpen
            }),
            isListOpen && jsxRuntime.jsx("div", {
                className: tailwindMerge.twJoin('absolute -bottom-2 z-40 translate-y-full transform transition-all', alignRight ? 'right-0' : 'left-0 '),
                "data-testid": "design-system-text-button-dropdown--list",
                children: jsxRuntime.jsx(List.Root, {
                    className: "max-h-full min-w-40 overflow-y-visible",
                    children: items.map((item, index)=>jsxRuntime.jsx(List.Item, {
                            text: item.value,
                            leadingIcon: item.leadingIcon,
                            onClick: ()=>handleItemClick(item),
                            selected: item.key === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.key),
                            isFocused: index === focusedIndex
                        }, item.key))
                })
            })
        ]
    });
};

module.exports = TextButtonDropdown;
